export default __webpack_public_path__ + "96ed276d9384f989b453f3287c3b398e.png";